<template>
  <main id="content" role="main">
    <!-- Page Header -->
    <div class="bg-primary" style="background-image: url(/themes/template/img/components/abstract-shapes-20.svg);">
      <div class="container space-2">
        <div class="row align-items-center">
          <div class="col">
            <div class="d-none d-md-block">
              <h1 class="h2 text-white">Versez votre taxe d'apprentissage</h1>
            </div>
            <div class="row">
              <a class="btn btn-info mx-1" href="#" role="button" @click="part=1">Formulaire</a>
              <a class="btn btn-info mx-1" href="#" role="button" @click="part=7">Soliciter entreprise</a>
              <a class="btn btn-info mx-1" href="#" role="button" @click="part=2">RIB</a>
              <a class="btn btn-info mx-1" href="#" role="button" @click="part=3">Bordereau</a>
              <a class="btn btn-info mx-1" href="#" role="button" @click="part=4">Reçu libératoire</a>
              <a class="btn btn-info mx-1" href="#" role="button" @click="part=5">Lettre versement</a>
              <a class="btn btn-info mx-1" href="#" role="button" @click="part=6">Demande reçu</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Description Section -->
    <div id="content_to_print" class="container space-2">

      <div v-if="part === 1">
        <form class="js-validate">

<!--      INFOS + CALCUL   -->
          <div v-if="!isCalculated">
            <div class="card mb-3 mb-lg-5">
              <div class="card-body">

            <div class="border-bottom mb-4">
              <h3>Entreprise</h3>
            </div>

            <!-- Form Group -->
            <div class="form-group">
              <label for="numero_siret" class="input-label">Numéro de siret </label>
              <input v-model="siret" @change="siret_info()" type="text" class="form-control" name="numero_siret" id="numero_siret" placeholder="000-000-000-00000" aria-label="siret">
            </div>
            <!-- End Form Group -->

            <div class="row">
              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="nom_entreprise" class="input-label">Nom entreprise</label>
                  <input v-model="nom_entreprise" type="text" class="form-control" name="nom_entreprise" id="nom_entreprise" placeholder="Entreprise" aria-label="nom_entreprise">
                </div>
                <!-- End Form Group -->
              </div>

              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="raison_social" class="input-label">Raison social</label>
                  <input v-model="raison_social" type="text" class="form-control" name="raison_social" id="raison_social" placeholder="Gaga mobile" aria-label="Gaga">
                </div>
                <!-- End Form Group -->
              </div>
            </div>
            <!-- End Row -->

            <!-- Form Group -->
            <div class="form-group">
              <label for="pro_address" class="input-label">Adresse</label>
              <input v-model="adresse_rue" type="text" class="form-control" name="pro_address" id="pro_address" placeholder="00 rue des abricots" aria-label="adresse">
            </div>
            <!-- End Form Group -->

            <div class="row">
              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="postal_code" class="input-label">Code postal</label>
                  <input v-model="CP" type="text" class="form-control" name="postal_code" id="postal_code" placeholder="78000" aria-label="postal_code">
                </div>
                <!-- End Form Group -->
              </div>

              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="city_name" class="input-label">Ville</label>
                  <input v-model="ville" type="text" class="form-control" name="city_name" id="city_name" placeholder="Versailles" aria-label="city_name">
                </div>
                <!-- End Form Group -->
              </div>
            </div>
            <!-- End Row -->
          </div>
            </div>

            <div class="card mb-3 mb-lg-5">
              <div class="card-body">

              <div class="border-bottom mb-4">
                <h3>Personne à contacter</h3>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <!-- Form Group -->
                  <div class="form-group">
                    <label for="firstName" class="input-label">Prénom</label>
                    <input v-model="firstName" type="text" class="form-control" name="firstName" id="firstName" placeholder="Nataly" aria-label="Nataly">
                  </div>
                  <!-- End Form Group -->
                </div>

                <div class="col-sm-6">
                  <!-- Form Group -->
                  <div class="form-group">
                    <label for="lastName" class="input-label">Nom</label>
                    <input v-model="lastName" type="text" class="form-control" name="lastName" id="lastName" placeholder="Gaga" aria-label="Gaga">
                  </div>
                  <!-- End Form Group -->
                </div>
              </div>
              <!-- End Row -->

              <!-- Form Group -->
              <div class="form-group">
                <label for="email" class="input-label">Email</label>
                <input v-model="email" type="email" class="form-control" name="email" id="email" placeholder="nayagaga@email.com" aria-label="alex@pixeel.com">
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="js-add-field form-group"
                   data-hs-add-field-options='{
                  "template": "#addPhoneFieldTemplate",
                  "container": "#addPhoneFieldContainer",
                  "defaultCreated": 0
                }'>
                <label for="phoneLabel" class="input-label">Téléphone</label>

                <div class="input-group align-items-center">
                  <input v-model="tel1" type="text" class="js-masked-input form-control" name="phone" id="phoneLabel" placeholder="+(xx)x-xx-xx-xx-xx" aria-label="+(xx)x-xx-xx-xx-xx"
                         data-hs-mask-options='{
                       "template": "+00 0-00-00-00-00"
                     }'>

                  <div class="input-group-append">
                    <!-- Select -->
                    <select class="js-custom-select custom-select dropdown-toggle" name="phoneSelect"
                            data-hs-select2-options='{
                        "minimumResultsForSearch": "Infinity",
                        "customClass": "custom-select",
                        "dropdownAutoWidth": true,
                        "width": true
                      }'>
                      <option value="Mobile" selected>Mobile</option>
                      <option value="Home">Personnel</option>
                      <option value="Work">Travail</option>
                      <option value="Fax">Fax</option>
                      <option value="Direct">Direct</option>
                    </select>
                    <!-- End Select -->
                  </div>
                </div>

                <!-- Container For Input Field -->
                <div id="addPhoneFieldContainer"></div>

                <a href="javascript:;" class="js-create-field form-link btn btn-xs btn-no-focus btn-ghost-primary">
                  <i class="fas fa-plus mr-1"></i>
                  Ajouter un numéro
                </a>
              </div>
              <!-- End Form Group -->

              <!-- Add Phone Input Field -->
              <div id="addPhoneFieldTemplate" style="display: none;">
                <div class="input-group input-group-add-field">
                  <input type="text" class="js-masked-input form-control" data-name="additionlPhone" placeholder="+x(xxx)xxx-xx-xx" aria-label="+x(xxx)xxx-xx-xx"
                         data-hs-mask-options='{
                       "template": "+0(000)000-00-00"
                     }'>

                  <div class="input-group-append">
                    <!-- Select -->
                    <select class="js-custom-select-dynamic btn btn-white dropdown-toggle"
                            data-name="additionlPhoneSelect"
                            data-hs-select2-options='{
                        "minimumResultsForSearch": "Infinity",
                        "customClass": "custom-select",
                        "dropdownAutoWidth": true,
                        "width": true
                      }'>
                      <option value="Mobile" selected>Mobile</option>
                      <option value="Home">Personnel</option>
                      <option value="Work">Travail</option>
                      <option value="Fax">Fax</option>
                      <option value="Direct">Direct</option>
                    </select>
                    <!-- End Select -->
                  </div>

                  <a class="js-delete-field input-group-add-field-delete" href="javascript:;">
                    <i class="fas fa-times"></i>
                  </a>
                </div>
              </div>
              <!-- End Add Phone Input Field -->

              <div class="form-check mt-4">
                <input type="checkbox" class="form-check-input" id="autorisation_donnees">
                <label class="form-check-label" for="autorisation_donnees">
                  <span class="font-weight-bold">J’autorise Rêves Partagés à collecter mes données personnelles</span>
                    , et à ne les divulguer qu'avec la personne concernée. Je peux me rétracter à tout moment.  </label>
              </div>
              </div>
            </div>

            <div class="card mb-3 mb-lg-5">
              <div class="card-body">

                  <div class="border-bottom mb-4">
                    <h3>Calcul de la taxe</h3>
                  </div>

                  <!-- End Form Group -->
                  <div class="row">
                    <div class="col-6">
                      <!-- Form Group -->
                      <div class="js-form-message form-group">
                        <label class="input-label" for="masse-salariale">Masse salariale
                          <i class="fa fa-question-circle ml-2" data-container="body" data-toggle="popover" data-placement="top"
                             data-trigger="hover" data-content="Lorem ipsum dolor sit amet"></i>
                        </label>
                        <div class="input-group">
                          <input type="number" min="0" class="form-control" name="masse-salariale" id="masse-salariale"
                                 aria-label="masse-salariale"
                                 v-model="masseSalariale" @keydown="clearZero($event)">
                          <div class="input-group-append">
                            <div class="input-group-text">€</div>
                          </div>
                        </div>
                      </div>

                      <!-- End Form Group -->

                    </div>
                    <div class="col-6">
                      <!-- Form Group -->
                      <div class="js-form-message form-group">
                        <label class="input-label" for="taxe-deduction">Déductions
                          <i class="fa fa-question-circle ml-2" data-container="body" data-toggle="popover" data-placement="top"
                             data-trigger="hover" data-content="Lorem ipsum dolor sit amet"></i>
                        </label>
                        <div class="input-group">
                          <input type="number" min="0" class="form-control" name="taxe-deduction" id="taxe-deduction"
                                 aria-label="taxe-deduction"
                                 v-model="deductions" @keydown="clearZero($event)">
                          <div class="input-group-append">
                            <div class="input-group-text">€</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Form Group -->

                  <!-- Form Group -->
                  <div class="row">
                    <div class="col-6">
                      <div class="js-form-message form-group">
                        <label class="input-label" for="taxe-brute">Taxe brute</label>
                        <div class="input-group">
                          <input type="number" class="form-control" name="taxe-brute" id="taxe-brute"
                                 aria-label="taxe-brute" disabled v-bind:value="taxeBrute">
                          <div class="input-group-append">
                            <div class="input-group-text">€</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="js-form-message form-group">
                        <label class="input-label" for="solde-thirteen">Montant du solde</label>
                        <div class="input-group">
                          <input type="number" class="form-control" name="solde-thirteen" id="solde-thirteen"
                                 aria-label="solde-thirteen" disabled v-bind:value="solde">
                          <div class="input-group-append">
                            <div class="input-group-text">€</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Form Group -->

                  <!-- Form Group -->
                  <div class="d-flex justify-content-end">
                    <p class="text-primary font-weight-bold font-size-2">Total à régler :
                      <span class="font-weight-bolder">{{totalToPay}}</span> €
                    </p>
                  </div>

                  <!-- Form Group -->
                  <div v-if="alert_msg != ''" class="d-flex justify-content-end">
                    <!-- End Form Group -->
                    <div class="alert alert-info" role="alert">
                      {{ alert_msg }}
                    </div>
                  </div>

                </div>
              <!-- Footer -->
              <div class="card-footer">
                <div class="d-flex justify-content-end align-items-center">
                  <button type="button" class="btn btn-primary"
                          @click="validateAmount()">
                    Valider montant <i class="fas fa-angle-right ml-1"></i>
                  </button>
                </div>
              </div>
              <!-- End Footer -->
            </div>
          </div>

          <div v-else class="card mb-3 mb-lg-5">
            <div class="card-body">
              <div class="border-bottom mb-4">
                <h3>Répartition du montant</h3>
              </div>
              <form class="">
                <div class="d-flex justify-content-center">
                  <h4 class="text-center border rounded border-primary p-3">
                    Montant restant : <span class="text-primary">{{leftAmount}}</span> €</h4>
                </div>
                <div class="row">
                  <div class="col-5">
                    <div class="js-form-message form-group">
                      <label class="input-label" for="etablissement1">Code UAI (RNE) // RAJOUTER L'API</label>
                      <div class="input-group">
                        <input type="text" class="form-control" name="uai1" id="uai1"
                               aria-label="uai1" v-model="currentUAI">
                      </div>
                    </div>
                  </div>

                  <div class="col-5">
                    <div class="js-form-message form-group">
                      <label class="input-label" for="etablissement1">Établissements (API)</label>
                      <div class="input-group">
                        <input type="text" class="form-control" name="etablissement1" id="etablissement1"
                               aria-label="etablissement1" v-model="currentEtablissement">
                      </div>
                    </div>
                  </div>

                  <div class="col-2">
                    <div class="js-form-message form-group">
                      <label class="input-label" for="montant1">Montant</label>
                      <div class="input-group">
                        <input type="number" class="form-control" name="montant1" id="montant1"
                               aria-label="montant1" @keyup="limitAmount($event)" v-model="currentAmount">
                        <div class="input-group-append">
                          <div class="input-group-text">€</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn btn-primary btn-sm ml-3" @click="addEtablissement()">Ajouter établissement</button>
                </div>

                <div id="taxe_repartition" class="space-1">

                  <table class="table">
                    <thead>
                    <tr>
                      <th>Code UAI</th>
                      <th>Établissement</th>
                      <th class="w-20">Montant (€)</th>
                      <th></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="etablissement in etablissements">
                      <td class="font-size-2 align-middle text-">{{ etablissement.UAI }}</td>
                      <td class="font-size-2 align-middle text-">{{ etablissement.name }}</td>
                      <td>
                        <div class="input-group">
                          <input type="number" class="form-control" style="font-size: 1.5rem" :data-taxe="etablissement.index"
                                 aria-label="" @keyup="updateField($event)"
                                 @focusin="clearField($event)"
                                 @focusout="updateEtablissement($event)"
                                 :value="etablissement.amount">
                          <div class="input-group-append">
                            <div class="input-group-text">€</div>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle">
                        <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                           data-toggle="tooltip" data-placement="top" title="Supprimer l'établissement"
                           @click="deleteEtablissement(etablissement.index)">
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </form>
            </div>

            <!-- Footer -->
            <div class="card-footer">
              <div class="d-flex justify-content-end align-items-center">
                <button type="button" class="btn btn-primary">
                  Finaliser ma demande <i class="fas fa-angle-right ml-1"></i>
                </button>
              </div>
            </div>
            <!-- End Footer -->
          </div>
        </form>

<!--    CONTENU MASQUE OH HE OH HE        -->
        <div class="d-none card mb-3 mb-lg-5">
          <div class="card-body">
            <div class="border-bottom mb-4">
              <h3>Choix des établissements receveurs</h3>
            </div>

            <p><span class="badge badge-info font-size-1 mr-2 my-2">Info : </span> Il s’agit ici de la taxe d’apprentissage de deuxième
              envergure (elle ne représente que 13% de la taxe totale).
            </p>

            <div class="row">
              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="code_uai" class="input-label">Code UAI (RNE) // RAJOUTER L'API</label>
                  <input v-model="uai" type="text" class="form-control" name="code_uai" id="code_uai" placeholder="1234567A" aria-label="code UAI">
                </div>
                <!-- End Form Group -->
              </div>

              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="nom_etablissement" class="input-label">Nom établissement</label>
                  <input v-model="found_name" readonly type="text" class="form-control" name="nom_etablissement"
                         id="nom_etablissement" placeholder="Lycée Emile Combes" aria-label="nom de l'établissement">
                </div>
                <!-- End Form Group -->
              </div>
            </div>
            <button type="button" class="btn btn-primary btn-sm" @click="addByUAI()">Ajouter établissement</button>

            <table class="table mt-4">
              <thead>
              <tr>
                <th>Nom établissement</th>
                <th>Code UAI</th>
                <th></th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="etablissement in etablissements">
                <td class="font-size-2 align-middle text-">
                  {{etablissement.found_name}}
                </td>
                <td>{{ etablissement.uai }}</td>
                <td class="align-middle">
                  <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                     data-toggle="tooltip" data-placement="top" title="Supprimer l'établissement"
                     @click="deleteEtablissement(etablissement.index)">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>

          </div>

          <!-- Footer -->
          <div class="card-footer">
            <div class="d-flex justify-content-end align-items-center">
              <button type="button" class="btn btn-primary">
                Finaliser ma demande <i class="fas fa-angle-right ml-1"></i>
              </button>
            </div>
          </div>
          <!-- End Footer -->
        </div>
      </div>

<!--      FORMULAIRE AJOUT ENTREPRISE-->
      <div v-if="part === 7">
        <div class="card mb-3 mb-lg-5">
          <div class="card-header" id="collapseButton">
            <h5 class="mb-0">
              <button class="btn btn-link text-primary"
                      data-toggle="collapse" data-target="#collapseAjoutEntr" aria-expanded="true" aria-controls="collapseAjoutEntr">
                Formulaire d'ajout d'entreprise
              </button>
            </h5>
          </div>

          <div id="collapseAjoutEntr" class="collapse show" aria-labelledby="collapseButton">
            <div class="card-body">

            <div class="border-bottom mb-4">
              <h3>Ajout entreprise</h3>
            </div>

            <!-- Form Group -->
            <div class="form-group">
              <label for="numero_siret2" class="input-label">Numéro de siret </label>
              <input v-model="siret" @change="" type="text" class="form-control" name="numero_siret2" id="numero_siret2" placeholder="000-000-000-00000" aria-label="siret">
            </div>
            <!-- End Form Group -->

            <div class="row">
              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="nom_entreprise2" class="input-label">Nom entreprise</label>
                  <input type="text" class="form-control" name="nom_entreprise2" id="nom_entreprise2" placeholder="Entreprise" aria-label="nom_entreprise">
                </div>
                <!-- End Form Group -->
              </div>

              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="activite" class="input-label">Activité de l'entreprise</label>
                  <input type="text" class="form-control" name="activite" id="activite" placeholder="Education" aria-label="Education">
                </div>
                <!-- End Form Group -->
              </div>
            </div>
            <!-- End Row -->

            <!-- Form Group -->
            <div class="form-group">
              <label for="mail_entreprise" class="input-label">Mail de l'entreprise</label>
              <input type="email" class="form-control" name="mail_entreprise" id="mail_entreprise" placeholder="00 rue des abricots" aria-label="adresse">
            </div>
            <!-- End Form Group -->

            <div class="row">
              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="date_stagiaire" class="input-label">Date du dernier stagiaire</label>
                  <input type="date" class="form-control" name="date_stagiaire" id="date_stagiaire" placeholder="01/02/2022" aria-label="01/02/2022">
                </div>
                <!-- End Form Group -->
              </div>

              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="nom_stagiaire" class="input-label">Nom du stagiare</label>
                  <input type="text" class="form-control" name="nom_stagiaire" id="nom_stagiaire" placeholder="Jean Dupont" aria-label="Jean Dupont">
                </div>
                <!-- End Form Group -->
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <!-- Form Group -->
                <div class="form-group">
                  <label for="prof_contact" class="input-label">Professeur en contact avec l'entreprise</label>
                  <input type="text" class="form-control" name="prof_contact" id="prof_contact" placeholder="Jeanne Calmant" aria-label="Jeanne Calmant">
                </div>
                <!-- End Form Group -->
              </div>

              <div class="col-sm-6">
                <div class="js-form-message form-group">
                  <label class="input-label" for="transactions">Montant des transactions avec l’entreprise</label>
                  <div class="input-group">
                    <input type="number" class="form-control" name="transactions" id="transactions"
                           aria-label="transactions">
                    <div class="input-group-append">
                      <div class="input-group-text">€</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

            <!-- Footer -->
            <div class="card-footer">
              <div class="d-flex justify-content-end align-items-center">
                <button type="button" class="btn btn-primary">
                  Valider <i class="fas fa-angle-right ml-1"></i>
                </button>
              </div>
            </div>
            <!-- End Footer -->
          </div>
        </div>

        <!-- Card -->
        <div class="card space-1">
          <!-- Header -->
          <div class="card-header">
            <h5 class="card-header-title">Liste des entreprises à solliciter</h5>
          </div>
          <!-- End Header -->

          <!-- Table -->
          <div class="table-responsive space-bottom-1" id="liste_entreprise">
            <table class="table table-borderless table-thead-bordered table-nowrap table-align-middle px-3">
              <thead class="thead-light">
              <tr class="align-middle">
                <th>Nom de l'entreprise</th>
                <th>Siret entreprise</th>
                <th>Activité de l’entreprise</th>
                <th>Mail de l’entreprise :</th>
                <th>Date du dernier stage</th>
                <th>Montant</th>
                <th style="width: 5%;"></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Bagelshtein</td>
                <td><a href="#">3682303</a></td>
                <td><span class="badge badge-soft-warning">Restauration</span></td>
                <td><a class="btn btn-xs btn-white" href="#"><i class="fas fa-phone mr-1"></i> Contacter l'entrprise</a></td>
                <td>22/04/2020</td>

                <td><a class="btn btn-xs btn-white" href="javascript:;" data-toggle="modal" data-target="#invoiceReceiptModal"><i class="fas fa-eye mr-1"></i> Voir le montant</a></td>
              </tr>
              </tbody>
            </table>
          </div>
          <a href="./form-taxe.html" class="btn btn-info">Ajouter une entreprise</a>

          <!-- End Table -->
        </div>
        <!-- End Card -->
      </div>

<!--      FORMULAIRE RIB-->
      <div v-if="part === 2" class="card mb-3 mb-lg-5">
        <div class="card-body">
          <div class="border-bottom mb-4">
            <h3>Je renseigne mon RIB</h3>
          </div>

          <div class="js-form-message form-group">
            <label class="input-label" for="iban">IBAN</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">FR</div>
              </div>
              <input type="number" class="form-control" name="iban" id="iban" aria-label="IBAN" >
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <!-- Form Group -->
              <div class="form-group">
                <label for="bic" class="input-label">BIC</label>
                <input type="text" class="form-control" name="bic" id="bic" placeholder="CRLYFRPPXXX" aria-label="CRLYFRPPXXX">
              </div>
              <!-- End Form Group -->
            </div>

            <div class="col-sm-6">
              <!-- Form Group -->
              <div class="form-group">
                <label for="titulaire" class="input-label">Nom du titulaire</label>
                <input type="text" class="form-control" name="titulaire" id="titulaire" placeholder="Dupont Jean" aria-label="Dupont Jean">
              </div>
              <!-- End Form Group -->
            </div>
          </div>

          <div class="form-check mt-4">
            <input type="checkbox" class="form-check-input" id="autorisation_compte">
            <label class="form-check-label" for="autorisation_compte">
              <span class="font-weight-bold">J’autorise Rêves Partagés à collecter mes données personnelles</span>
              , et à ne les divulguer qu'avec la personne concernée. Je peux me rétracter à tout moment.  </label>
          </div>
        </div>

        <div class="card-footer">
          <div class="d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-primary">
              Valider mes données
            </button>
          </div>
        </div>
      </div>

<!--      BORDEREAU DE VERSEMENT-->
      <div v-if="part === 3" class="card mb-3 mb-lg-5">
        <div class="card-body px-10">
          <p class="text-right font-weight-bold">TAXE D’APPRENTISSAGE 2022 Bordereau de Versement </p>
          <h3 class="text-center">13% solde de la TA</h3>
          <p class="text-justify">Nous vous remercions de bien vouloir compléter les informations ci-dessous afin de nous
            permettre de vous transmettre le reçu libératoire qui vous permettra de justifier de votre versement de
            la fraction de 13% de la taxe d’apprentissage. Les versements sont à effectuer avant le 31 mai 2022. </p>
          <p>Mail de contact pour l’établissement : etablissement@academie.fr</p>

          <h4 class="text-center">Votre entreprise</h4>
          <div class="border border-primary p-3">
            <p>Raison sociale : </p>
            <p>Adresse : </p>
            <p>Code postal : </p>
            <p>Ville : </p>
            <p>SIRET : </p>
            <h6>Contact de la personne en charge de la taxe d’apprentissage</h6>
            <p>Nom : </p>
            <p>Téléphone : </p>
            <p>E-mail : </p>
          </div>

          <h4 class="text-center">Versement</h4>
          <div class="border border-primary p-3">
            <h5 class="text-center">Montant de votre versement</h5>
            <h6 class="text-center">XXXX €</h6>
          </div>

          <h4 class="text-center">Réf établissement UAI : 12345678A</h4>

          <h5>Référence bancaire</h5>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <td class="text-center" style="background-color: #999999" scope="row" colspan="6">Identifiant national de compte bancaire - RIB</td>
              </tr>
              <tr>
                <td>Code banque</td>
                <td>Code guichet</td>
                <td>N° de compte</td>
                <td>Clé RIB</td>
                <td></td>
                <td>Domiciliation</td>
              </tr>
              <tr>
                <td>123456</td>
                <td>456789</td>
                <td>987654321</td>
                <td>12</td>
                <td></td>
                <td>Ville</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-bordered">
            <tbody>
            <tr>
              <td class="text-center" style="background-color: #999999" scope="row" colspan="9">
                IBAN (International Bank Account Number)</td>
            </tr>
            <tr>
              <td colspan="7">Code banque</td>
              <td></td>
              <td>BIC</td>
            </tr>
            <tr>
              <td>FR12</td>
              <td>3456</td>
              <td>7890</td>
              <td>1234</td>
              <td>5678</td>
              <td>9012</td>
              <td>3456</td>
              <td></td>
              <td>ABCDEFG1</td>
            </tr>
            </tbody>
          </table>

          <h5 style="text-decoration: underline">TITULAIRE DU COMPTE :</h5>
          <h5>Nom établissement</h5>

          <div class="d-inline-flex justify-content-between w-100 mt-4">
            <h6 class="ml-5">Date</h6>
            <h6 class="mr-5">Signature</h6>
          </div>

          <p><span class="font-italic">A réception de votre règlement, vous recevrez votre reçu libératoire attestant de votre soutien.</span> Lycée
            du Vexin 2 rue Jean Hamon 95750 CHARS Siret : 19951282300014 APE 8532Z</p>
        </div>
      </div>

<!--      RECU LIBERATOIRE -->
      <div v-if="part === 4" class="card mb-3 mb-lg-5">
        <div class="card-body px-10">
          <h3>RECU LIBERATOIRE AU TITRE DU SOLDE DE LA TAXE D’APPRENTISSAGE</h3>
          <div class="border border-primary p-3">
            <h4>Année de la Taxe d’apprentissage : </h4>
            <h4>Année de salaires : </h4>
          </div>

          <h4 class="mt-3" style="text-decoration: underline">Identité de l’Etablissement :</h4>
          <ul>
            <li>Nom : </li>
            <li>Nom du responsable : </li>
            <li>Adresse : </li>
            <li>Code Postal : </li>
            <li>Ville : </li>
            <li>Téléphone : </li>
          </ul>

          <p>Je soussigné
            <br>
            certifie avoir reçu le montant de XXXX €
            <br>
            au titre de la Taxe d’apprentissage de la part de l’Entreprise :
          </p>

          <h4 style="text-decoration: underline">Identité de l’Entreprise :</h4>
          <ul>
            <li>Nom Entreprise : </li>
            <li>SIRET : </li>
            <li>IDDC : </li>
            <li>Adresse : </li>
            <li>Code Postal : </li>
            <li>Ville : </li>
            <li>Téléphone : </li>
          </ul>

          <p>Fait à
          <br>
          le</p>

          <p class="mt-5">Signature et cachet de l’Etablissement</p>
        </div>
      </div>

<!--      VERSEMENT SOLDE APPRENTISSAGE -->
      <div v-if="part === 5" class="card mb-3 mb-lg-5">
        <div class="card-body px-10">
          <h5 class="text-right">Nom de l'établissement</h5>
          <h5 class="text-right font-weight-normal">Numéro et rue</h5>
          <h5 class="text-right font-weight-normal">Code Postal et ville</h5>

          <h5 class="mt-10 ">Objet : versement solde apprentissage</h5>
          <h5 class="text-right font-weight-normal">Lieu, date</h5>

          <p>Madame, Monsieur,</p>
          <p>Notre entreprise a choisi votre établissement pour se libérer du solde de 13% de sa taxe apprentissage et ce
            conformément à la légalisation en vigueur afin de favoriser le développement des formations initiales
            technologiques et professionnelles.
            A cet effet, nous vous prions de bien vouloir trouver ci-joint un chèque HSBC N° <span>…………………………</span> pour un montant
            de <span>…………</span> €. Par ailleurs, vous trouverez ci-dessous les éléments nécessaires à la rédaction de notre reçu fiscal :
          </p>

          <p class="mt-4">Raison sociale :
          <br>SIRET :
          <br>Adresse :
          <br>Code Postal :
          <br>Ville :
          <br>Tél. :
          <br>E-mail :
          </p>

          <p class="mt-4">Vous souhaitant bonne réception de la présente,</p>

          <p class="mt-4">Nous vous prions d’agréer, Madame, Monsieur, l’expression  de nos salutations distinguées.</p>

          <p class="text-center mt-4">La Comptabilité
          <br>Mme XXXXXXXXXXXX Xxxxxx
          </p>

          <p class="mt-4">PJ : un chèque</p>

        </div>
      </div>

<!--      DEMANDE DE RECU LIBERATOIRE -->
      <div v-if="part === 6" class="card mb-3 mb-lg-5">
        <div class="card-body px-10">
          <h5>Nom de l'entreprise</h5>
          <h5 class="font-weight-normal">Numéro et rue</h5>
          <h5 class="font-weight-normal">Code Postal et ville</h5>

          <h5 class="text-right">Nom de l'établissement</h5>
          <h5 class="text-right font-weight-normal">Numéro et rue</h5>
          <h5 class="text-right font-weight-normal">Code Postal et ville</h5>

          <h5 class="mt-10 ">Objet : Taxe apprentissage 2022 – Paiement du solde de 13%</h5>
          <h5 class="text-right font-weight-normal">Lieu, date</h5>

          <p>Madame, Monsieur,</p>
          <p>Veuillez trouver ci-joint le paiement du solde de 13% de la Taxe d’apprentissage de 2022 à votre
            établissement d’un montant de <span>……………………</span> euros.
          </p>

          <p class="mt-4">Merci de nous délivrer en retour un reçu libératoire permettant de justifier cette dépense.</p>

          <p class="mt-4">Je vous prie d’agréer, Madame, Monsieur, mes sincères salutations.</p>

          <p class="text-right mt-4">Nom contact entreprise</p>
          <p class="text-right">Fonction</p>

        </div>
      </div>

  </div>
  </main>

</template>

<script>
export default {
  name: "DlnkTaxeApprentissage",
  data: function () {
    return {
      part: 1,
      masseSalariale: 0,
      deductions: 0,
      taxeBrute: 0,
      solde: 0,
      totalToPay: 0,
      currentAmount: 0,

      partMasseSalariale: 0.0068,
      partTaxeBrute: 0.13,

      isCalculated: false,
      leftAmount: 0,
      isExonarated: false,
      taxe_content: Node,


      etablissements: [],
      currentUAI: "",
      currentEtablissement: "",
      alert_msg: "",
      uai: "",
      found_name: "",
      siret: "",
      nom_entreprise: "",
      raison_social: "",
      adresse_rue: "",
      CP: "",
      ville: "",

      firstName: "",
      lastName: "",
      email: "",
      tel1: "",

      //Entreprise à soliciter

    }
  },

  watch: {
    masseSalariale: function(){
      this.calculateTax()
    },
    deductions: function(){
      this.calculateTax()
    },
  },

  methods: {

    calculateTax: function ()
    {
        this.taxeBrute = Math.round(this.masseSalariale * this.partMasseSalariale)
        this.solde = Math.round(this.taxeBrute * this.partTaxeBrute)
        this.totalToPay = Math.max(0, Math.round(100 * (this.solde - this.deductions)) / 100)
        this.alert_msg = ""
        this.isExonarated = false
    },

    validateAmount: function(){
      this.leftAmount = parseFloat(this.totalToPay);
      this.isCalculated = true;
    },

    limitAmount: function (event){
      this.currentAmount = Math.min(this.currentAmount, this.leftAmount)
    },

    clearZero: function (event){
      if(event.target.value === 0)
        event.target.value = ""
    },

    clearField: function (event){
      this.spendTaxe(-parseFloat(event.target.value))
      this.etablissements[event.target.getAttribute("data-taxe")].amount = 0
    },

    updateField: function (event){
      event.target.value = Math.min(event.target.value, this.leftAmount)
    },

    siret_info: async function () {
      const _this = this

      if (_this.siret.length !== 14) {
        _this.invalid_siret = true
        return false
      }

      _this.invalid_siret = false

      const api_url = "https://entreprise.data.gouv.fr/api/sirene/v3/etablissements/" + _this.siret

      axios.get(api_url)
          .then(function (response) {
            _this.siret_details = response.data
            _this.nom_entreprise = _this.siret_details.etablissement.unite_legale.denomination
            _this.CP = _this.siret_details.etablissement.unite_legale.etablissement_siege.code_postal
            _this.ville = _this.siret_details.etablissement.unite_legale.etablissement_siege.libelle_commune
            _this.adresse_rue = _this.siret_details.etablissement.unite_legale.etablissement_siege.geo_l4
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    addByUAI: function(){
      if(this.found_name === "")
      {
        alert("Il n'y a pas d'établissement qui correspond au code UAI saisi");
        return ;
      }
      let newEtablissement = new Object();
      newEtablissement.uai = this.uai;
      newEtablissement.found_name = this.found_name;
      newEtablissement.index = this.etablissements.length;

      this.etablissements.push(newEtablissement);

      this.uai = "";
      this.found_name = "";
    },

    deleteEtablissement: function (index) {
      this.spendTaxe(-parseFloat(this.etablissements[index].amount))
      this.etablissements.splice(index, 1)
      this.etablissements.forEach(function(etablissement) {
            if (etablissement.index > index) {
              etablissement.index--
            }
          }
      )
    },

    updateEtablissement: function (event){
      this.etablissements[event.target.getAttribute("data-taxe")].amount = event.target.value
      this.spendTaxe(event.target.value)
    },

    addEtablissement: function()
    {
      if(this.currentAmount == 0)
      {
        alert("Veuillez choisir un montant supérieur à 0")
        return
      }
      let newEtablissement = new Object();
      newEtablissement.UAI = this.currentUAI;
      newEtablissement.name = this.currentEtablissement;
      newEtablissement.amount = this.currentAmount;
      newEtablissement.index = this.etablissements.length;
      this.etablissements.push(newEtablissement);
      this.spendTaxe(this.currentAmount);
      this.currentUAI = "";
      this.currentEtablissement = "";
      this.currentAmount = 0;
    },

    spendTaxe: function(newAmount){
      this.leftAmount -= parseFloat(newAmount)
    },
  }
}

</script>

<style scoped>
  input[disabled]{
    background-color: #e0e0ff;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .pdf-tab input{
    border: none;
  }

  td{
    color: black;
  }
</style>